import SanityClient from "./sanity/node_modules/@sanity/client";

export const client = SanityClient({
    projectId: "rpwjfknd",
    dataset: "production",
    useCdn: true,
    apiVersion: "2021-10-21",
});
